export const getUuid = (state) => state.client.user.data[2]
export const getUserType = (state) => state.client.user.data[5]
export const getLoggedInEmail = (state) => state.client.user.data[1]
export const getFirstName = (state) => state.client.user.data[3]
export const getLastName = (state) => state.client.user.data[4]
export const getTaxCardData = (state) => state.form.tax.loadData
